import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';

@Component({
  selector: '[section3]',
  imports: [
    ContainerComponent,
    PictureComponent,
    GlobalButtonComponent
  ],
  templateUrl: './section3.component.html',
  styleUrl: './section3.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    id: 'talk-to-the-experts'
  }
})
export class Section3Component { }
